import React from "react";
import { useSelector } from "react-redux";

import { T, FONT_STACK } from "../customer/customers.theme";
import mark from "../../assets/images/dalabtire-mark.png";

/**
 * The left corner of the app bar: the product, then the shop.
 *
 * It was empty. The mark lives at the top of the rail, but the app bar is
 * fixed, full width and sits a layer above the drawer, so it covered the mark
 * completely — the corner of the screen showed nothing at all.
 *
 * And the shop's own name appeared nowhere. A person signed into one of two
 * businesses could see whose account they were using and not which shop they
 * were in, which is the more expensive of the two to get wrong.
 *
 * So: mark, wordmark, hairline, business name. It reads as one sentence —
 * this is Dalabtire, you are in Xamar Restaurant.
 */
export default function AppBrand() {
  const activeUser = useSelector((state) => state.login?.activeUser);
  const businessName = activeUser?.business?.businessName || "";

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        // No padding of its own: the Toolbar around it sets the inset, so the
        // wordmark lines up with the left edge of the page content.
        minWidth: 0,
        fontFamily: FONT_STACK,
      }}
    >
      <img
        src={mark}
        alt="Dalabtire"
        style={{
          width: "35px",
          height: "35px",
          borderRadius: "8px",
          objectFit: "cover",
          flexShrink: 0,
        }}
      />

      <span
        style={{
          fontSize: "17px",
          fontWeight: 800,
          letterSpacing: "-0.3px",
          color: T.brand,
          whiteSpace: "nowrap",
        }}
      >
        Dalabtire
      </span>

      {businessName ? (
        <React.Fragment>
          <span style={{ width: "1px", height: "22px", background: T.border, flexShrink: 0 }} />

          {/* Truncated rather than wrapped: the bar is one line high, and a
              long shop name must not push the account menu off the end. */}
          <span
            style={{
              fontSize: "14.5px",
              fontWeight: 600,
              color: T.ink,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "320px",
            }}
            title={businessName}
          >
            {businessName}
          </span>
        </React.Fragment>
      ) : null}
    </div>
  );
}
